webpackJsonp([258756445527569],{

/***/ 435:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>This infection of the liver is caused by the hepatitis C virus. About 3.9 million people in the U.S. have the disease. But it causes few symptoms, so most of them don't know.\nThere are many forms of the hepatitis C virus. The most common in the U.S. is type 1. None is more serious than any other, but they respond differently to treatment.</p>\n<p><a href=\"https://www.webmd.com/hepatitis/digestive-diseases-hepatitis-c#1\">via WebMD</a></p>","frontmatter":{"path":"webmd-definition","title":"What is Hepatitis C? (WebMD)","date":"2018-05-11","tags":["hepatitis","infection","cirrhosis"]}}},"pathContext":{"slug":"webmd-definition"}}

/***/ })

});


// WEBPACK FOOTER //
// path---article-webmd-definition-e4363a927fd86149d947.js